export default __webpack_public_path__ + "static/media/videocase3.90f99066.png";